import React, { useState, useContext } from "react";
import { Row, Col, Modal, Container } from "react-bootstrap";
import "./SignUp.css";
import originallogo1 from "../../../Assets/Images/logo.png";
import originallogo2 from "../../../Assets/Images/logo.png";
import Field from "../../../Components/Fields/Fields";
import { Inputs, Validation, config } from "./config.js";
// import { Link } from 'react-router-dom'
import string from "../../../Assets/Localization/Local";
import { LangContext } from "../../../App";

const SignUp = (props) => {
  const { lang } = useContext(LangContext);
  const [show, setShow] = useState(true);
  const dimButton = {
    width: "100%",
    padding: "5px",
    borderRadius: "36px",
    margin: "0 auto",
    outline: "none",
    border: "none",
    fontSize: "16px",
    fontWeight: "600",
    backgroundColor: "#171717",
  };
  const btnSignUpStyle = {
    width: "70%",
    padding: "13px",
    borderRadius: "10px",
    margin: "0 auto",
    marginTop: "20px",
    outline: "none",
    border: "none",
    backgroundColor: "#171717",
    fontSize: "16px",
    fontWeight: "600",
  };
  string.setLanguage(lang);
  return (
    <div>
      <Modal
        style={{ direction: lang === "ar" ? "rtl" : "ltr" }}
        show={show}
        onHide={props.close}
        animation={false}
        className="AuthModal"
      >
        <Modal.Body className="p-0">
          <Container fluid>
            <Row className="justify-content-between authbody">
              <Col
                md="5"
                className="authlogo px-0"
                style={{
                  borderLeft: lang === "ar" ? "1px solid #EBEBEB" : "",
                  borderRight: lang === "en" ? "1px solid #EBEBEB" : "",
                }}
              >
                <i
                  style={{
                    left: lang === "ar" ? "10px" : "",
                    right: lang === "en" ? "10px" : "",
                  }}
                  onClick={props.close}
                  className="fas fa-times closeBTNresponsive"
                >
                  {" "}
                </i>
                <div style={{ margin: "auto" }}>
                  <img
                    src={lang === "ar" ? originallogo1 : originallogo2}
                    alt="logo"
                  />
                </div>
              </Col>
              <Col
                md="7"
                className="px-0 fixcloseresponsive"
                style={{ paddingBottom: "40px", paddingTop: "50px" }}
              >
                <Field
                  dimButton={dimButton}
                  inputs={Inputs}
                  validation={Validation}
                  config={config}
                  SubmitBtnStyle={btnSignUpStyle}
                />
                <i
                  style={{
                    left: lang === "ar" ? "10px" : "",
                    right: lang === "en" ? "10px" : "",
                  }}
                  onClick={props.close}
                  class="fas fa-times closeBTN"
                ></i>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default SignUp;
